import { render, staticRenderFns } from "./cpMajorTab.vue?vue&type=template&id=511aee72&scoped=true&"
import script from "./cpMajorTab.vue?vue&type=script&lang=js&"
export * from "./cpMajorTab.vue?vue&type=script&lang=js&"
import style0 from "./cpMajorTab.vue?vue&type=style&index=0&id=511aee72&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "511aee72",
  null
  
)

export default component.exports